"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("../../elements/Typography"));

var _TimeDisplay = _interopRequireDefault(require("./TimeDisplay.css"));

// Thanks to https://github.com/moment/moment/issues/580#issuecomment-380091244
_moment.default.updateLocale('en', {
  meridiem: function meridiem(hours, _, isLower) {
    if (hours > 11) {
      return isLower ? 'p' : 'P';
    } else {
      return isLower ? 'a' : 'A';
    }
  }
});
/**
 * This should handle a range rather than only the from time.
 * This has been pushed to later to accomodate the current frontend needs.
 */


var TimeDisplay =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(TimeDisplay, _React$PureComponent);

  function TimeDisplay() {
    (0, _classCallCheck2.default)(this, TimeDisplay);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimeDisplay).apply(this, arguments));
  }

  (0, _createClass2.default)(TimeDisplay, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          from = _this$props.from,
          to = _this$props.to;
      var momentFrom = _moment.default.isMoment(from) ? from : (0, _moment.default)(from);
      var momentTo = _moment.default.isMoment(to) ? to : (0, _moment.default)(to); // can also possibly show difference in day, but needs designs

      var sameMinute = momentFrom.isSame(momentTo, 'minute');
      return React.createElement("div", {
        className: classes.container
      }, React.createElement(_Typography.default, {
        variant: 'dateDisplay',
        className: "top ".concat(classes.top)
      }, momentFrom.format('dddd')), React.createElement(_Typography.default, {
        variant: 'dateDisplay',
        className: 'bottom'
      }, momentFrom.format('h:mma'), !sameMinute && React.createElement(React.Fragment, null, React.createElement("span", {
        className: classes.divider
      }, "\u2014"), momentTo.format('h:mma'))));
    }
  }]);
  return TimeDisplay;
}(React.PureComponent);

TimeDisplay.propTypes = {
  /**
   * The time that will be treated as a from time.
   */
  from: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date), PropTypes.instanceOf(Object)]).isRequired,

  /**
   * The time that will be treated as a to time.
   */
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date), PropTypes.instanceOf(_moment.default)])
};

var _default = (0, _styles.withStyles)(_TimeDisplay.default)(TimeDisplay);

exports.default = _default;